import { useGetIdentity, useListContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { SortButton } from "@/components/admin/sort-button";
import { Card } from "@/components/ui/card";

import { ListPageHeader } from "../../gravun/list/ListPageHeader";
import { CompanyEmpty } from "./CompanyEmpty";
import { CompanyListFilter } from "./CompanyListFilter";
import { CompanyListContent } from "./CompanyListContent";

export const CompanyList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={false}
      pagination={<ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />}
    >
      <CompanyListLayout />
    </List>
  );
};

const CompanyListLayout = () => {
  const translate = useTranslate();
  const { data, isPending, filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;

  if (isPending) return null;
  if (!data?.length && !hasFilters) return <CompanyEmpty />;

  return (
    <>
      <ListPageHeader
        title="Companies"
        subtitle="Manage organizations and customer accounts"
        actions={
          <>
            <SortButton fields={["name", "created_at", "nb_contacts"]} />
            <ExportButton />
            <CreateButton
              label={translate("resources.companies.action.new", {
                _: "New Company",
              })}
            />
          </>
        }
      />
      <div className="flex w-full flex-row gap-6">
        <CompanyListFilter />
        <div className="flex min-w-0 flex-1 flex-col gap-4">
          <Card className="overflow-x-auto py-0">
            <CompanyListContent />
          </Card>
        </div>
      </div>
    </>
  );
};
